export const joinClassNames = (...classes) => {
  // filter out instances of undefined
  return classes
    .filter(item => {
      return item
    })
    .join(' ')
}
